module.exports = "<app-header-slider></app-header-slider>\n<app-services></app-services>\n<app-about-clinic></app-about-clinic>\n<app-doctors></app-doctors>\n"